export default __webpack_public_path__ + "static/media/001.b9168869.jpg";